import {
  Activity,
  Bell,
  Boxes,
  Camera,
  Cpu,
  Database,
  Eye,
  FileText,
  Palette,
  Rocket,
  Shield,
  Usb,
  Volume2,
  Waves,
  Wifi,
} from 'lucide-react'
import type {Category, CategoryId} from '@/lib/types'

export const CATEGORIES: Record<CategoryId, Category> = {
  storage: {
    id: 'storage',
    title: 'Storage',
    blurb: 'Persisting data on the client — from cookies to OPFS.',
    color: 'oklch(60% 0.14 250)',
    icon: Database,
  },
  network: {
    id: 'network',
    title: 'Network',
    blurb: 'Talking to servers and peers.',
    color: 'oklch(60% 0.14 180)',
    icon: Wifi,
  },
  'media-capture': {
    id: 'media-capture',
    title: 'Media Capture',
    blurb: 'Camera, microphone, screen sharing.',
    color: 'oklch(60% 0.14 30)',
    icon: Camera,
  },
  'audio-video': {
    id: 'audio-video',
    title: 'Audio & Video',
    blurb: 'Synthesis, playback, speech.',
    color: 'oklch(60% 0.14 60)',
    icon: Volume2,
  },
  graphics: {
    id: 'graphics',
    title: 'Graphics',
    blurb: '2D canvas, WebGL, WebGPU.',
    color: 'oklch(60% 0.14 295)',
    icon: Palette,
  },
  sensors: {
    id: 'sensors',
    title: 'Sensors',
    blurb: 'Position, orientation, battery, pressure.',
    color: 'oklch(60% 0.14 145)',
    icon: Activity,
  },
  hardware: {
    id: 'hardware',
    title: 'Hardware',
    blurb: 'USB, HID, Serial, Bluetooth, NFC.',
    color: 'oklch(60% 0.14 220)',
    icon: Usb,
  },
  identity: {
    id: 'identity',
    title: 'Identity & Security',
    blurb: 'WebAuthn, credentials, crypto, permissions.',
    color: 'oklch(60% 0.14 0)',
    icon: Shield,
  },
  'platform-ui': {
    id: 'platform-ui',
    title: 'Platform UI',
    blurb: 'Notifications, share, wake lock, clipboard.',
    color: 'oklch(60% 0.14 120)',
    icon: Bell,
  },
  workers: {
    id: 'workers',
    title: 'Workers',
    blurb: 'Background processing & off-main-thread.',
    color: 'oklch(60% 0.14 200)',
    icon: Cpu,
  },
  files: {
    id: 'files',
    title: 'Files',
    blurb: 'File API, File System Access.',
    color: 'oklch(60% 0.14 90)',
    icon: FileText,
  },
  observation: {
    id: 'observation',
    title: 'Observation',
    blurb: 'IntersectionObserver, ResizeObserver and friends.',
    color: 'oklch(60% 0.14 160)',
    icon: Eye,
  },
  frontier: {
    id: 'frontier',
    title: 'Frontier',
    blurb: 'Newer additions that change how the web works.',
    color: 'oklch(60% 0.14 320)',
    icon: Rocket,
  },
  streams: {
    id: 'streams',
    title: 'Streams',
    blurb: 'Pipe data through readers, transformers, and writers.',
    color: 'oklch(60% 0.14 210)',
    icon: Waves,
  },
  components: {
    id: 'components',
    title: 'Components',
    blurb: 'Custom elements, shadow DOM, templates.',
    color: 'oklch(60% 0.14 270)',
    icon: Boxes,
  },
}

export const CATEGORY_ORDER: CategoryId[] = [
  'storage',
  'files',
  'streams',
  'network',
  'workers',
  'observation',
  'platform-ui',
  'components',
  'media-capture',
  'audio-video',
  'graphics',
  'sensors',
  'hardware',
  'identity',
  'frontier',
]
